import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import CTeEventoCode from "./CTe.Evento.Code";
import CTeEventoModalPropriedades from "./Modal.Propriedades/CTe.Evento.Modal.Propriedades";
import { CTeEventoDto } from "./CTe.Evento.Dto";
import CTeEventoModalCadastro from "./Modal.Cadastro/CTe.Evento.Modal.Cadastro";
import React from "react";

const CTeEventoView = () => {
  const code = CTeEventoCode();

  return (
    <Container>
      <HeadPage headText="Eventos CT-e">
        <Dropdown.Item
          as={Button}
          onClick={() => code.onShowModalCadastro(true)}
        >
          Incluir...
        </Dropdown.Item>
      </HeadPage>
      {!code.loading ? (
        <Col>
          {code.data && code.data.length > 0 ? (
            <Table responsive hover>
              <thead>
                <tr>
                  <th className="col-4">Tipo Evento</th>
                  <th className="col-4">Justificativa / Correção</th>
                  <th className="col-4">Envio Descrição</th>
                </tr>
              </thead>
              <tbody>
                {code.data.map((item: CTeEventoDto) => (
                  <React.Fragment key={item.id}>
                    <tr
                      style={{ cursor: "pointer" }}
                      onClick={code.handleClickPropriedades(item)}
                    >
                      <td className="col-4">
                        {item.tipoEventoDescricao || item.tipoEvento}
                      </td>
                      <td className="col-4">
                        {item.cancelamento?.justificativaCancelamento}
                        {item.correcoes && item.correcoes.length > 0 && (
                          <span>
                            {item.correcoes.length === 1
                              ? `${item.correcoes[0].campoAlterado}: ${item.correcoes[0].valorAlterado}`
                              : `${item.correcoes.length} correções (${item.correcoes
                                  .map((c) => c.campoAlterado)
                                  .join(", ")})`}
                          </span>
                        )}
                      </td>
                      <td className="col-4">
                        {item.codigoStatusEnvioDescricao}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3} className="p-2 text-muted">
                        {item.codigoStatusResposta
                          ? `${item.codigoStatusResposta} - ${item.descricaoMotivoResposta}`
                          : item.descricaoMotivoResposta || "Sem retorno da SEFAZ"}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          ) : (
            <Form.Text>Sem Dados</Form.Text>
          )}
        </Col>
      ) : (
        <Placeholder animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
      <CTeEventoModalPropriedades
        show={code.modalShowPropriedades}
        evento={code.evento}
        onReturn={code.onReturnModalPropriedades}
        onSend={code.onSendModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
      />
      <CTeEventoModalCadastro
        show={code.modalShowCadastro}
        cteId={code.cteId}
        onClose={code.onShowModalCadastro}
        onReload={code.onReloadModalPropriedades}
      />
    </Container>
  );
};

export default CTeEventoView;
